import React, {useEffect} from "react"
import MicroApp from "commons/MicroApp"
import {mzUseNavigate} from "utils"
import {HttpService} from "../../../service/HttpService"
import {getNavPathFromType, NavigationType} from "@jnext/commons"
import {useAppStore} from "store/appStore"
import {AuthService} from "../../../service/AuthService"

export const ResetPassword: React.FC = () => {
  const {handleResponseError} = useAppStore()
  const navigate = mzUseNavigate()

  useEffect(() => {
    localStorage.clear()
    AuthService.logoutClean()
    AuthService.saveUrlExtraParametersToLocalStorage(window.location.search)
  }, [])

  return (<>
      {HttpService.env?.coreUser && (
        <MicroApp
          entry={`${HttpService.env?.coreUser}`}
          props={{
            type: "reset-password",
            onNavigate( type: NavigationType ) {
              navigate(getNavPathFromType(type))
            },
            onError: handleResponseError,
            keyCloakClientId: HttpService.env?.keycloakClientID as string
          }}
        />
      )}
    </>
  )
}
